import React from 'react';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import Radium from 'radium';
import moment from 'moment';
import { Switch, Icon, DarkText } from '@lyearn-team/frontend-components';
import { withTheme } from 'emotion-theming';
import Base from '../../../../helper';
import HTMLCardDark from './HTMLCardDark';
import HTMLV2CardDark from './HTMLV2CardDark';
import EMBEDDark from './EmbedDark';
import AudioCardDark from './AudioCardDark/index';
import VideoPlayerDark from './VideoCardDark';
// import QuizCard from './QuizCard';
import PDFCardDark from './PDFCardDark';
import ChannelContent from '../ChannelContent';
import s from './styles';

const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100%'
  },
  rootContainerMobile: {
    padding: '20px'
  },
  previewContainer: {
    height: 'calc(100% - 86px)'
  },
  contentWrapper: {
    maxWidth: '960px',
    width: '100%',
    marginBottom: '26px',
    display: 'flex',
    flexDirection: 'column',
    margin: '0px auto',
    position: 'relative',
    zIndex: '2',
    paddingTop: '40px',
    height: '100%'
  },
  contentWrapperForPDF: {
    margin: '0px auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  cardName: {
    fontSize: '10px',
    lineHeight: '16px',
    letterSpacing: '0.8px',
    fontWeight: '500',
    textTransform: 'uppercase',
    margin: '4px 0 16px',
    color: '#898989',
    fontFamily: 'ChronicaPro'
    // paddingLeft: '10px'
  },
  cardNameMobile: {
    fontSize: '10px',
    lineHeight: '16px',
    letterSpacing: '0.8px',
    fontWeight: '500',
    textTransform: 'uppercase',
    margin: '4px 0 16px',
    color: '#898989',
    fontFamily: 'ChronicaPro',
    paddingLeft: '10px'
  },
  switchTheme: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    right: '15px'
  },
  switchText: {
    marginRight: '12px'
  }
};
@withTheme
@Radium
class ChannelCardDark extends Base {
  static propTypes = {
    rootQ: PropTypes.object
  };

  static contextTypes = {
    nextPressed: PropTypes.func,
    prevPressed: PropTypes.func
  };

  state = {
    showNarration: false,
    type: ''
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(newProps) {
    // console.log('here',this.props.rootQ.pid , newProps.rootQ.pid);
    if (this.state.showNarration && this.props.rootQ.pid !== newProps.rootQ.pid) {
      this.state.showNarration = false;
    }
  }

  componentDidMount() {
    if (this.props.isPreview) {
      this.setState({ type: 'dark' });
    }
  }

  onSwitchChange = e => {
    const type = e.target.checked ? 'dark' : 'light';
    const { isPreview } = this.props;
    if (!isPreview) {
      window.location.href =
        '/#/learner/channels/' +
        this.props.params.channelId +
        '/card/' +
        this.props.params.cardId +
        '/' +
        type;
    } else {
      this.setState({ type });
    }
  };

  render() {
    const isMobile = window.innerWidth < 768;
    const { type } = this.state;
    const { isPreview } = this.props;
    const checked = this.props.params.type === 'dark' || type === 'dark';
    // const styles = this.styles;
    const updatedAt = moment(this.props.rootQ.updatedAt).format('D MMM, YYYY');
    const HTML_V2 = this.props.rootQ.channelCardType === 'HTML_V2';
    console.log({ ChannelContent: this });
    return (
      <div className={s.root}>
        <div
          style={[
            styles.contentWrapper,
            this.props.rootQ.channelCardType === 'PDF' ? styles.contentWrapperForPDF : null,
            isMobile ? styles.rootContainerMobile : null,
            isPreview ? styles.previewContainer : null
          ]}
        >
          <ChannelContent
            title={this.props.rootQ.name}
            date={updatedAt}
            isMobile={isMobile}
            HTML_V2={HTML_V2}
            darkTheme={checked}
          />
          {HTML_V2 && (
            <span style={styles.switchTheme} className={s.switchContainer}>
              <Icon
                type="lightTheme"
                height={16}
                width={16}
                style={{ marginRight: !isMobile ? '9px' : '12px' }}
              />
              {!isMobile && (
                <DarkText
                  fontSize={12}
                  color="iron"
                  letterSpacing="normal"
                  className={s.switchLabel(true)}
                  uppercase={false}
                >
                  Light
                </DarkText>
              )}
              <Switch
                checked={checked}
                size="small"
                onChange={this.onSwitchChange}
                className={s.toggleSwitch}
              />
              <Icon
                type="darkTheme"
                height={16}
                width={16}
                style={{
                  marginRight: !isMobile ? '9px' : '0px',
                  marginLeft: '14px'
                }}
              />
              {!isMobile && (
                <DarkText
                  fontSize={12}
                  color="iron"
                  letterSpacing="normal"
                  className={s.switchLabel()}
                  uppercase={false}
                >
                  Dark
                </DarkText>
              )}
            </span>
          )}
          {this.renderCardContents()}
        </div>
      </div>
    );
  }

  handleNarratClick() {
    this.setState({
      showNarration: !this.state.showNarration
    });
  }

  /**
   * This event is fired when video has 'ended'
   */
  @autobind
  videoEndedEvent() {
    this.context.nextPressed && this.context.nextPressed();
  }

  renderCardContents() {
    const { isPreview } = this.props;
    if (!this.props.rootQ.channelCardType) return null;
    switch (this.props.rootQ.channelCardType) {
      case 'VIDEO':
        return (
          <VideoPlayerDark
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ}
            videoEndedEvent={this.videoEndedEvent}
          />
        );
      case 'AUDIO':
        return (
          <AudioCardDark
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ}
            isPreview={isPreview}
          />
        );
      case 'HTML':
        return (
          <HTMLCardDark
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ}
            narrationUrl={this.props.rootQ.narrationUrl || null}
            showNarration={this.state.showNarration}
          />
        );
      case 'EMBED':
      case 'WEB_URL':
        return (
          <EMBEDDark
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ}
            narrationUrl={this.props.rootQ.narrationUrl || null}
            showNarration={this.state.showNarration}
          />
        );
      case 'HTML_V2':
        return (
          <HTMLV2CardDark
            cardId={this.props.rootQ.pid}
            card={this.props.rootQ}
            narrationUrl={this.props.rootQ.narrationUrl || null}
            showNarration={this.state.showNarration}
            params={{ type: this.state.type, ...this.props.params }}
            isPreview={isPreview}
          />
        );
      case 'PDF':
        return <PDFCardDark cardId={this.props.rootQ.pid} card={this.props.rootQ} />;
      default:
        console.log('New card type found ', this.props.rootQ.channelCardType);
        throw new Error('no card type found');
    }
  }
}

export default ChannelCardDark;
